import { postRawRequest } from '../../httpClient';

export async function fillMissingClipsApi(collectionId: number): Promise<Response> {
  return postRawRequest({
    path: `/sys/pipeline/${collectionId}/fill-missing-clips`,
    options: { timeout: 300_000 },
  });
}
